export default "__VITE_ASSET__152a3444__"